import {
  Box,
  Button,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LoaderView from "components/LoaderView";
import { IS_APPROVER, KILL_CWK_AUTO, IS_NO_EMAIL, EmailDomain, ITContractor } from "config/CONSTANTS";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
// I18n
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
//import { deepEqual  } from "BulkUpload/components/utils";
import { getLocationForCountry } from "services/bulkUpload";
import {
  addContingentWorker,
  addWorkerRoles,
  editContingentWorker,
  getDetailsByEmail,
  getNewCwkId,
  getUserDetails,
  getWorkerRoles,
  resetWorkerPin,
} from "services";
// import { getRcArrayParam, getWarehouseRegions } from "services/firebase";
import {
  getWorkerGdeRole,
  getWorkerSchedule,
  getWorkerTransportRole,
  getWorkerSBSRole,
  getWorkerSecurebaseRole,
  getWorkerIMTimeRole,
  getWorkerCrozierRole,
  getSmartSortUserRole,
  getWorkerGorpaRole
} from "services/workerSchedule";
import { isEmptyObject } from "utils/index";
import ManagerLookup from "../../components/ManagerLookup";
import SectionHead from "../../components/SectionHead";
import { MANAGE_WORKERS, ROOT } from "../../navigation/CONSTANTS";
import { properCase, deepEqual } from "../../utils";
import { classes as workerStyles } from "./AddWorkerStyles";
import { Validator } from "./components/validator2";
import WorkerSchedule from "./components/WorkerSchedule";
import DelegateManager from "components/DelegateManager";
import { gdePermissionOpts } from "./components/utils";

import {
  ADD,
  ALREADY_EXISTS,
  EDIT,
  EMAIL,
  EMPLOYEE_ID,
  EMPTY,
  INCORRECT_ENTRY,
  IS_ACTIVE_WORKER,
  MAIL_FORMAT_RE,
  NUMBER_RE,
  PENDING,
  REQUIRED,
  ERROR_WHILE_SAVE,
  BILLRATE_REQUIRES,
  SERVICE_COS,
  OPERATIONAL_DISTRICT_BUILDING,
  OPERATIONS
} from "./config";
//Bill Rate
import { currencyData } from "./currency";
import UserAccess from "./UserAccess";
import { getWorker, getJobRole } from "./utils";
import { convertStringToArray, convertStringToObject } from "utils/rcUtils";
import { useRemoteConfig } from "providers";
import CountryLookup from "components/CountryLookup";
import GdeUserAccess from "./components/GdeUserAccess";
import TransportUserAccess from "./components/TransportUserAccess";
import SBSUserAccess from "./components/SBSUserAccess";
import SecurebaseUserAccess from "./components/SecurebaseUserAccess";
import CrozierUserAccess from "./components/CrozierUserAccess";
import ImtRoleAccess from "./components/ImtRoleAccess";
import GorpaAccess from "./components/GorpaAccess";
import SmartSortUser from "./components/SmartSortUser";
import { useTimezoneSelect, allTimezones } from 'react-timezone-select';
const useStyles = makeStyles((theme) => workerStyles(theme));

const ValidatorInstance = Validator.instance();

export const AddWorkerView = (props) => {
  const { setShowUpload } = props;
  const { user, isAuthenticated } = useSelector((state) => state.user.auth);
  const { jobFamilies, workdayConfig, managerCostCenterData } = useSelector((state) => state.appConfig);
  const imWarehouseRegions = useRemoteConfig("region", "imWarehouse");
  const imWarehouseCountries = useRemoteConfig("imWarehouseCountries");
  const history = useHistory();
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isScheduleLoading, setIsScheduleLoading] = useState(true);
  const [isGdeLoading, setIsGdeLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const location = useLocation();
  const [isWorkerGde, setIsWorkerGde] = useState(false);
  const [isGdeEdit, setIsGdeEdit] = useState(false);
  
  const [contingentWorker, setContingentWorker] = useState({
    isActiveWorker: true,
    isManager: false,
    isApprover: false,
    email: "",
    phone: "",
    agency: "",
    otherId: "",
    billRate: "",
    currency: "",
    jobRole: "",
    jobDepartment: OPERATIONS,
    timezone: {},
    costCenter: "",
    product:"",
    function:SERVICE_COS.function,
    costCenterId: "",
    productId:"",
    functionId:SERVICE_COS.id,
    approvingManager: [],
    pin: "",
    isNoEmail: true,
    jobType: "",
    operationalBuilding:[],
    operationalDistrict:[]
  });
  const [empId, setEmpId] = useState("");
  const worker =
    location.state && location.state.worker ? location.state.worker : {};

  const approveForMgr =
    location.state && location.state.approveForManager
      ? location.state.approveForManager
      : {};
   console.log("add worker bill/currency show",approveForMgr);

  const [showBillRate, setShowBillRate] = useState(false);
  const [isApprover, setIsApprover] = useState(false);
  const [isActiveWorker, setActiveWorker] = useState(true);
  const [selectedRegion, setSelectedRegion] = useState({});
  const [workerRoles, setWorkerRoles] = useState({});
  const [regions, setRegions] = useState({});
  const [warehouseCountries, setWarehouseCountries] = useState("");
  const [workingHourData, setWorkingHourData] = useState({});
  const [gdeData, setGdeData] = useState({});
  const altCountryAccess = useRemoteConfig("alternateCountryAccess");
  const altCountryAccessCountries = convertStringToArray(altCountryAccess);
  const [isAltCountryEnabled, setAltCountryEnabled] = useState(false);
  const [jobRoles, setJobRoles] = useState([]);
  const [gdeValid, setGdeValid] = useState(true);
  const [isResetPinVisible, setIsResetPinVisible] = useState(true);
  const [isResetPinDisabbled, setIsResetPinDisabbled] = useState(true);
  const [isPinReset, setIsPinReset] = useState(false);
  const [transportData, setTransportData] = useState({});
  const [sbsData, setSBSData] = useState({});
  const [securebaseData, setSecurebaseData] = useState({});
  const [imTimeRoleData, setImtimeRoleData] = useState({});
  const [crozierData, setCrozierData] = useState({});
  const [transportValid, setTransportValid] = useState(true);
  const [sbsValid, setSbsValid] = useState(true);
  const [securebaseValid, setSecurebaseValid] = useState(true);
  const [iMtimeValid, setIMtimeValid] = useState(true);
  const [sbsDistBuilingMap, setSbsDistBuilingMap] = useState({});
  const [securebaseDistBuilingMap, setSecurebaseDistBuilingMap] = useState({});
  const [smartSortDistBuilingMap, setSmartSortDistBuilingMap] = useState({});
  const [crozierValid, setCrozierValid] = useState(true);
  const [isTransportDataLoading, SetIsTransportDataLoading] = useState(true);
  const [isSBSDataLoading, SetIsSBSDataLoading] = useState(true);
  const [isSecurebaseDataLoading, SetIsSecurebaseDataLoading] = useState(true);
  const [isIMtimeDataLoading, SetIsIMtimeDataLoading] = useState(true);
  const [isCrozierDataLoading, SetIsCrozierDataLoading] = useState(true);
  const [isTransportWorker, setIsTransportWorker] = useState(false);
  const [isSbsWorker, setIsSbsWorker] = useState(false);
  const [isSecurebaseWorker, setIsSecurebaseWorker] = useState(false);
  const [isIMtimeWorker, setIsIMtimeWorker] = useState(false);
  const [isGorpaWorker, setIsGorpaWorker] = useState(false);
  const [GorpaValid, setGorpaValid]= useState(true);
  const [gorpaRoleData, setGorpaRoleData] = useState({});
  const [isGorpaDataLoading, setIsGorpaDataLoading]=useState(true);
  const [isCrozierWorker, setIsCrozierWorker] = useState(false);
  const [crozierDistBuilingMap, setCrozierDistBuilingMap] = useState({});
  const pinAccess = useRemoteConfig("pinAccess");
  const pinAccessCountries = convertStringToArray(pinAccess);
  const [isNoEmail, setIsNoEmail] = useState(false);
  const [tempIsNoEmail, setTempIsNoEmail] = useState(false);
  const [isSmartSortDataLoading, setIsSmartSortDataLoading] = useState(true);
  const [smartSortValid, setSmartSortValid] = useState(true);
  const [smartSortUserData, setSmartSortUserData] = useState({});
  const [isSmartSortWorker, setIsSmartSortWorker] = useState(false);
  const [costCenterOptions, setCostCenterOptions]=useState([]);
  const [productOptions, setProductOptions]=useState([]); 
  const [functionOptions, setFunctionOptions]=useState([]);
  const jobTypes = useRemoteConfig("jobTypes");
  const jobTypeOptions=jobTypes? convertStringToArray(jobTypes): [];
  const jobDepartments = useRemoteConfig("jobDepartments");
  const jobDepartmentOptions = jobDepartments ? convertStringToArray(jobDepartments) : [];
  const [operationalDistricts, setOperationalDistricts] = useState([]);
  const [operationalBuildings, setOperationalBuildings] = useState([]);
  const [isWarehouseDataLoading, setIsWarehouseDataLoading] = useState(true);
  
  // show bulk upload functionality if Add Contingent Worker mode is ON
  // Hide ulk upload functionality if Add Contingent Worker mode is OFF
  if (isEmptyObject(worker)) {
    setShowUpload(true);
  } else {
    setShowUpload(false);
  }

  useEffect(() => {
    if (!isEmptyObject(worker) && !contingentWorker.pin) {
      setIsResetPinDisabbled(true);
    } else {
      setIsResetPinDisabbled(false);
    }
  }, [contingentWorker, isPinReset]);

  useEffect(() => {
    setContingentWorker((state) => ({ ...state, pin: "" }));
    setIsResetPinDisabbled(true);
  }, [isPinReset]);

  useEffect(() => {
    if (jobFamilies && i18n) {
      const language = i18n.language;
      const values = jobFamilies[language]
        ? jobFamilies[language]
        : jobFamilies["en"];

      // console.log("Values", values)
      setJobRoles(values);
    }
  }, [jobFamilies, i18n]);


  useEffect(() =>{
    if(user){
        if(!isEmptyObject(worker)){
          setShowBillRate(worker.managerId === user.workerId)
        }else {
          if(contingentWorker.manager && contingentWorker.manager.managerId){
            setShowBillRate(contingentWorker.manager.managerId === user.workerId)
          }
        }
    }
    
    console.log("contigent worker",contingentWorker)

  },[user,worker,approveForMgr,contingentWorker])

  useEffect(() =>{
    if(workdayConfig && Object.keys(workdayConfig).length > 0){
      
        let {costCenters = [], functions = [], products = []} = workdayConfig;
        if(costCenters && costCenters.length>0){
          costCenters.sort((a,b) => a.costCenter.toLowerCase() > b.costCenter.toLowerCase() ? 1:-1);
          setCostCenterOptions(costCenters);
        }
        if(functions && functions.length>0){
          functions.sort((a,b) => a.function.toLowerCase() > b.function.toLowerCase() ? 1:-1);
          setFunctionOptions(functions);
        }
        if(products && products.length>0){
          products.sort((a,b) => a.product.toLowerCase() > b.product.toLowerCase() ? 1:-1);
          setProductOptions(products)
        }
      
      console.log("workday config", workdayConfig)
    }
  },[workdayConfig])
  useEffect(() => {
 getLocationForCountry(
          worker?.countryCode,
          worker?.alternateCountryCode
       ).then((data) => {
            let districtBuildingObj={};
           // console.log("datass",data);
            data.forEach((record)=>{
              let DistOperationalEnabled = false;
              let buildingIdMap ={};
              Object.entries(record.buildings).map((buildingDet)=>{
               if(buildingDet[1].activityEnabled === true){
                //if(true){
                  DistOperationalEnabled =true;
                  buildingIdMap[buildingDet[0]]={
                    buildingID:buildingDet[0],
                    districtID:record.district,
                    
                  };
                }
              });
              if(buildingIdMap && Object.keys(buildingIdMap).length>0){
                districtBuildingObj[record.district] =buildingIdMap; 
              }
              record.DistOperationalEnabled = DistOperationalEnabled;
            });
           const  filteredDistricts = data.filter((record)=> record.DistOperationalEnabled === true);
              setOperationalDistricts([...filteredDistricts]);
              console.log("districtBuildingObj",districtBuildingObj);
            console.log("operationalDistricts",...filteredDistricts);
          })
          .catch((err) => {
            console.log("Get districts in Operational District Building DATA error ", err);
          })
  }, []);

  useEffect(() => {
    console.log("Which worker", worker);
    if (Object.keys(worker) != 0)
      if (worker && worker.workerId) {
        setIsResetPinVisible(true);
        setIsScheduleLoading(true);
        setIsGdeLoading(true);
        SetIsTransportDataLoading(true);
        SetIsSBSDataLoading(true);
        SetIsSecurebaseDataLoading(true);
        SetIsIMtimeDataLoading(true);
        setIsGorpaDataLoading(true);
        SetIsCrozierDataLoading(true);
        setIsGorpaDataLoading(true);
        if (worker.isNoEmail !== undefined) {
          setIsNoEmail(worker.isNoEmail);
          setTempIsNoEmail(worker.isNoEmail);
        }
        if (worker.isNoEmail == undefined || worker.isNoEmail == null) {
          setIsNoEmail(false);
        }
        if (worker.email !== undefined && worker.email !== worker.workerId + EmailDomain) {
          setIsNoEmail(false);
        }
        getWorkerSchedule(worker.workerId)
          .then((schedule) => {
            setWorkingHourData(schedule);
            methods.reset(schedule);
            setIsScheduleLoading(false);
          })
          .catch(() => {
            setWorkingHourData({});
            methods.reset();
            setIsScheduleLoading(false);
          });

        getWorkerGdeRole(worker.workerId)
          .then((data) => {
            console.log("data gde in try", data);
            setGdeData(data);
            if (!isEmptyObject(data)) {
              setIsGdeEdit(true);
            }
            // methods.reset(data);
            setIsGdeLoading(false);
          })
          .catch(() => {
            setGdeData({});
            methods.reset();
            setIsGdeLoading(false);
          });

        getWorkerTransportRole(worker.workerId)
          .then((data) => {
            console.log("data transport in try", data);
            setTransportData(data);
            // methods.reset(data);
            SetIsTransportDataLoading(false);
          })
          .catch(() => {
            setTransportData({});
            methods.reset();
            SetIsTransportDataLoading(false);
          });

        getWorkerSBSRole(worker.workerId)
          .then((data) => {
            console.log("data SBS in try", data);
            setSBSData(data);
            // methods.reset(data);
            SetIsSBSDataLoading(false);
          })
          .catch(() => {
            setSBSData({});
            methods.reset();
            SetIsSBSDataLoading(false);
          });

          getWorkerSecurebaseRole(worker.workerId)
          .then((data) => {
            console.log("data Securebase in try", data);
            setSecurebaseData(data);
            // methods.reset(data);
            SetIsSecurebaseDataLoading(false);
          })
          .catch(() => {
            setSecurebaseData({});
            methods.reset();
            SetIsSecurebaseDataLoading(false);
            console.log("data Securebase in try fail");
          });

        getSmartSortUserRole(worker.workerId)
          .then((data) => {

            console.log("data Smart SortUser in try", data);
            setSmartSortUserData(data);
            // methods.reset(data);
            setIsSmartSortDataLoading(false);
          })
          .catch((err) => {
            console.log("smart sort api fatch fail" + err)
            setSmartSortUserData({});
            methods.reset();
            setIsSmartSortDataLoading(false);
          });


        getWorkerIMTimeRole(worker.workerId)
          .then((data) => {
            console.log("data imtRole in try", data);
            setImtimeRoleData(data);
            // methods.reset(data);
            SetIsIMtimeDataLoading(false);
          })
          .catch(() => {
            setImtimeRoleData({});
            methods.reset();
            SetIsIMtimeDataLoading(false);
          });

          getWorkerGorpaRole(worker.workerId)
          .then((data)=>{
            console.log("data gorpaRole in try", data);
            setGorpaRoleData(data);
            setIsGorpaDataLoading(false);
          })
          .catch(()=>{
            setGorpaRoleData({});
            methods.reset();
            setIsGorpaDataLoading(false);
          })
          
        getWorkerCrozierRole(worker.workerId)
          .then((data) => {
            console.log("data transport in try", data);
            setCrozierData(data);
            // methods.reset(data);
            SetIsCrozierDataLoading(false);
          })
          .catch(() => {
            setCrozierData({});
            methods.reset();
            SetIsCrozierDataLoading(false);
          });
      } else {
        setWorkingHourData({});
        setGdeData({});
        setTransportData({});
        setSBSData({});
        setImtimeRoleData({});
        setGorpaRoleData({});
        setCrozierData({});
        setSmartSortUserData({});
        methods.reset();
        setIsScheduleLoading(false);
        setIsGdeLoading(false);
        SetIsTransportDataLoading(false);
        SetIsSBSDataLoading(false);
        SetIsSecurebaseDataLoading(false);
        SetIsIMtimeDataLoading(false);
        setIsGorpaDataLoading(false);
        SetIsCrozierDataLoading(false);
        setIsResetPinVisible(false);
        setIsSmartSortDataLoading(false);
        setIsWarehouseDataLoading(false)
      }
    else {
      setIsScheduleLoading(false);
      setIsGdeLoading(false);
      SetIsTransportDataLoading(false);
      SetIsSBSDataLoading(false);
      SetIsSecurebaseDataLoading(false);
      SetIsIMtimeDataLoading(false);
      setIsGorpaDataLoading(false);
      SetIsCrozierDataLoading(false);
      setIsResetPinVisible(false);
      setIsSmartSortDataLoading(false);
      setIsWarehouseDataLoading(false);
    }
  }, [worker]);

  //Bill rate, find the unique currency data
  let mymap = new Map();

  const distinctCurrencyData = currencyData.filter((el) => {
    const val = mymap.get(el.currency_code);
    if (val) {
      if (el.id < val) {
        mymap.delete(el.currency_code);
        mymap.set(el.currency_code, el.country);
        return true;
      } else {
        return false;
      }
    }
    mymap.set(el.currency_code, el.country);
    return true;
  });

  const validateWorkerRoles = () => {
    let errorWorkerRoles = false;
    if (workerRoles !== null && !isEmptyObject(workerRoles)) {
      const systems = regions.systems;
      if (systems && systems.length > 0) {
        for (let i = 0; i < systems.length; i++) {
          const system = systems[i];
          if (selectedRegion[system].length > 0) {
            const accessDetails = workerRoles[system];
            selectedRegion[system].forEach((region) => {
              if (
                accessDetails &&
                accessDetails[region] &&
                ((accessDetails[region].error &&
                  accessDetails[region].error === "Required") ||
                  !accessDetails[region].userId ||
                  (accessDetails[region].userId &&
                    accessDetails[region].userId === ""))
              ) {
                accessDetails[region].error = "Required";
                errorWorkerRoles = true;
              }
            });
          }
        }
      }
      setError(errorWorkerRoles);
    }
    return !errorWorkerRoles;
  };

  const updateCostCenter = (managerId) =>{
    if(managerId && worker && isEmptyObject(worker)){
    let managerData = managerCostCenterData[managerId];
       console.log('userrrrr', managerData);
       if(managerData && Object.keys(managerData).length >0){
         setContingentWorker((state) => ({
           ...state,
           costCenter: managerData.costCenter && managerData.costCenterId ? managerData.costCenter : '',
           costCenterId: managerData.costCenter && managerData.costCenterId ? managerData.costCenterId : '',
           product: managerData.product && managerData.productId ? managerData.product : '',
           productId : managerData.product && managerData.productId ? managerData.productId : ''
         }));
       }
      }
  }

  useEffect(() =>{
    if(user &&  user.isApprover && managerCostCenterData){
      if (worker && isEmptyObject(worker)) {
        let managerId = approveForMgr && !isEmptyObject(approveForMgr) && approveForMgr.managerId
         ? approveForMgr.managerId : user.workerId;
         updateCostCenter(managerId);
      } 
    }
  },[user, managerCostCenterData])

  useEffect(() => {
    if (location.state && location.state.empId) {
      setEmpId(location.state.empId);
    } else if (user && !(user.isManager || user.isApprover)) {
      console.log("User is not a manager! Please verify your employee ID");
      history.push(ROOT);
    } else {
      let manager;
      if (approveForMgr && !isEmptyObject(approveForMgr)) {
        manager = approveForMgr;
      } else {
        manager = {
          managerFirstName: user.firstName,
          managerLastName: user.lastName,
          managerId: user.workerId,
          managerEmail: user.email,
        };
      }
      setContingentWorker((state) => ({
        ...state,
        country: user.country,
        manager: manager,
      }));
    }

    let rcRegions;
    if (user.country) {
      // let countries = getProvisionedCountries();
      // let countries = getRcArrayParam("imWarehouseCountries");
      let countries = convertStringToArray(imWarehouseCountries);
      // console.log("warehouse", countries)
      // let countries = convertStringToArray(imWarehouseCountries);
      countries = countries.toString().toLowerCase().split(",");
      setWarehouseCountries(countries);
      if (countries.includes(user.country.toLowerCase())) {
        // const rcRegions = getRcArrayParam('region');
        // const rcRegions = JSON.parse(getWarehouseRegions());
        // rcRegions = getWarehouseRegions();
        rcRegions = convertStringToObject(imWarehouseRegions);
        // console.log("getWarehouse", rcRegions);
        const systems = Object.keys(rcRegions);
        let selectedRegion = {};
        systems.map((item) => {
          selectedRegion[item] = [];
        });
        rcRegions.systems = systems;
        setRegions(rcRegions);
        setSelectedRegion(selectedRegion);
      }
    }

    if (worker && !isEmptyObject(worker)) {
      enableAlternateCountry(worker.country);
      setActiveWorker(worker.isActiveWorker);
      setIsApprover(worker.isApprover || false);
      let manager = {
        managerFirstName: worker.managerFirstName,
        managerLastName: worker.managerLastName,
        managerId: worker.managerId,
        managerEmail: worker.managerEmail,
      };
      let contingentWorker = worker;
      if(worker && !worker.operationalBuilding){
        contingentWorker.operationalBuilding=[];
      }else if(worker && worker.operationalBuilding && !Array.isArray(worker.operationalBuilding)){
        contingentWorker.operationalBuilding=[worker.operationalBuilding];
      }
      if(worker && !worker.operationalDistrict){
        contingentWorker.operationalDistrict=[];
      }else if(worker && worker.operationalDistrict && !Array.isArray(worker.operationalDistrict)){
        contingentWorker.operationalDistrict=[worker.operationalDistrict];
      }
      contingentWorker.employeeId = worker.workerId;
      contingentWorker.manager = manager;

      if (worker.alternateCountry) {
        contingentWorker.alternateCountry = {
          countryName: worker.alternateCountry,
          id: worker.alternateCountryCode,
        };
      }

      if(worker && (!worker.function  || !worker.functionId)){
        contingentWorker.function = SERVICE_COS.function;
        contingentWorker.functionId = SERVICE_COS.id;
      }

      if(worker && !worker.jobDepartment){
        contingentWorker.jobDepartment = OPERATIONS;
      }

      setContingentWorker(contingentWorker);

      getWorkerRoles(worker.workerId)
        .then((data) => {
          if (data && !isEmptyObject(data)) {
            setWorkerRoles(data);
            if (rcRegions && rcRegions.systems) {
              rcRegions.systems.map((item) => {
                if (data.selectedRegion && data.selectedRegion[item]) {
                  setSelectedRegion((state) => ({
                    ...state,
                    [item]: data.selectedRegion[item],
                  }));
                }
              });
            }
          }
          setIsWarehouseDataLoading(false);
        })
        .catch((err) => {
          console.error(
            "Add Worker View: Err in getWorkerRoles Response: ",
            err
          );
          setIsWarehouseDataLoading(false);
        });
    } else {
      if (approveForMgr && !isEmptyObject(approveForMgr)) {
        if (!approveForMgr.managerCountry) {
          getUserDetails(approveForMgr.managerId).then((data) => {
            approveForMgr.managerCountry = data.data().country;
            enableAlternateCountry(approveForMgr.managerCountry);
          });
        } else {
          enableAlternateCountry(approveForMgr.managerCountry);
        }
      } else {
        enableAlternateCountry(user.country);
      }
    }
    setIsLoading(false);
  }, [user]);

  useEffect(() => {
    console.log("operationalDistrict", contingentWorker.operationalDistrict);
    if(operationalDistricts && operationalDistricts.length > 0){
    const newValue = contingentWorker.operationalDistrict;
      if(!newValue || newValue.length<=0){
        // setValue('sbsBuilding', []);
        setOperationalBuildings([]);
        setContingentWorker((state) => ({ ...state, 
        operationalBuilding: []}));
      }
      else{
        let activatedBuildings =[];
          operationalDistricts.forEach(record => {
            if(newValue.includes(record.district)){
              const buildingsData = record.buildings ? record.buildings : {};
              let buildingIds = Object.keys(buildingsData).filter(
                (e) => buildingsData[e].activityEnabled === true
              );
              activatedBuildings.push(...buildingIds);
            }
          })
          const currentBuildings = contingentWorker.operationalBuilding ? contingentWorker.operationalBuilding : [];
          if(currentBuildings.length > 0){
            const filteredBuldings = currentBuildings.filter(record => activatedBuildings.includes(record) || record == OPERATIONAL_DISTRICT_BUILDING.Building);
            setContingentWorker((state) => ({ ...state, 
              operationalBuilding: [...filteredBuldings]}));
          }
      console.log("activatedBuildings",activatedBuildings);
      setOperationalBuildings(activatedBuildings);
      }
    }
  }, [contingentWorker.operationalDistrict, operationalDistricts])

  const [saveDisabled, setSaveDisabled] = useState(true);
  const errorMessageData = {
    firstName: EMPTY,
    lastName: EMPTY,
    email: EMPTY,
    country: EMPTY,
    manager: EMPTY,
    isActiveWorker: EMPTY,
    isApprover: EMPTY,
    agency: EMPTY,
    billRate: EMPTY,
    currency: EMPTY,
  };
  const [errorMessage, setErrorMessage] = useState(errorMessageData);
  const [isError, setError] = useState(true);
  const [confirmationMsg, setConfirmationMsg] = useState(false);
  const [newWorkerId, setNewWorkerId] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const [scheduleValid, setScheduleValid] = useState(true);
  const [errorExceptionMsg, setErrorExceptionMsg] = useState(false);

  const spacing = 1;

  const methods = useForm({
    // resolver: yupResolver(getValidationSchema()),
    mode: "all",
    // defaultValues: {
    //   ...defaultValues
    // },
    // shouldUnregister: true,
  });

  const { handleSubmit, formState } = methods;
  const { isDirty, isSubmitting } = formState;

  const [isValid, setIsValid] = useState(true);

  let listener = (valid) => {
    setIsValid(valid);
  };

  useEffect(() => {
    ValidatorInstance.addListener(listener);

    return () => (listener = null);
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    console.log("Target id", target.id);
    let value =
      target.id === IS_ACTIVE_WORKER || target.id === IS_APPROVER || target.id === IS_NO_EMAIL
        ? target.checked
        : target.value;

    if (target.id === IS_ACTIVE_WORKER) {
      setActiveWorker(value);
      setContingentWorker((state) => ({ ...state, [target.id]: value }));
      setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
    } else if (target.id === IS_APPROVER) {
      // setIsManager(value);
      setImtimeRoleData({
        ...imTimeRoleData, role: target.checked ? "Supervisor" : "Worker",
        isActive: true
      })
      setIsApprover(value);
      setContingentWorker((state) => ({ ...state, [target.id]: value }));
      setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
    }
    else if (target.id === "timezone") {
    
      setContingentWorker((state) => ({ ...state, [target.id]: value }));
      setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
    } 
    else if (target.id === IS_NO_EMAIL) {
      // setIsManager(value);
      setIsNoEmail(value);
      setContingentWorker((state) => ({ ...state, [target.id]: value }));
      setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
    }
    else if (target.id === "jobType"){
      setContingentWorker((state) => ({ ...state, [target.id]: value }));
      setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
      if(value && value == ITContractor && !contingentWorker.operationalDistrict.length && !contingentWorker.operationalBuilding.length){
        setContingentWorker((state) => ({ ...state, 
          operationalBuilding: OPERATIONAL_DISTRICT_BUILDING.Building, 
          operationalDistrict: OPERATIONAL_DISTRICT_BUILDING.District}));
      }
    }
     else {
      if (value && value !== null) {
        value = target.id === "phone" ? target.value.replace(/[^0-9]/g, "") : value;
        value = target.id === "email" ? target.value.toLowerCase() : value;
        if(target.id === "costCenter" || target.id === "product" || target.id === "function"){
          setContingentWorker((state) => ({ ...state, [target.id]: value[target.id], [`${target.id}Id`]:value['id'] }));
        }else{
        setContingentWorker((state) => ({ ...state, [target.id]: value }));
        }
        setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
      } else if (
        target.id === "email" ||
        target.id === "phone" ||
        target.id === "otherId" ||
        target.id === "billRate" ||
        target.id === "currency" || 
        target.id === "operationalDistrict" || 
        target.id === "operationalBuilding" 

      ) {
        setContingentWorker((state) => ({ ...state, [target.id]: EMPTY }));
        setErrorMessage((state) => ({ ...state, [target.id]: EMPTY }));
      } else {
        setContingentWorker((state) => ({ ...state, [target.id]: EMPTY }));
        setErrorMessage((state) => ({ ...state, [target.id]: REQUIRED }));
      }
    }

    //Set empId for self
    if (empId && !contingentWorker.employeeId) {
      setContingentWorker((state) => ({ ...state, employeeId: empId }));
      setContingentWorker((state) => ({ ...state, isActiveWorker: true }));
    }
  };

  const handleEmailChange = async (event) => {
    const target = event.target;
    const value = target.value.toLowerCase();
    const invalidEmail = await validateEmail(value);
    if (!invalidEmail) {
      setContingentWorker((state) => ({ ...state, [EMAIL]: value }));
    }
  };

  const handleBillRateCurrencyChange = async (event) => {
    const target = event.target;
    const eventId = event.target.id;
    const value = target.value;
    if (!value || value == null) {
      if (eventId === "currency" && contingentWorker.billRate) {
        setError(true);
        setErrorMessage((state) => ({ ...state, billRateText: EMPTY }));
        setErrorMessage((state) => ({ ...state, currencyText: REQUIRED }));
        setSaveDisabled(true);
      } else if (eventId === "billRate" && contingentWorker.currency) {
        setError(true);
        setErrorMessage((state) => ({ ...state, currencyText: EMPTY }));
        setErrorMessage((state) => ({ ...state, billRateText: REQUIRED }));
        setSaveDisabled(true);
      } else {
        setContingentWorker((state) => ({ ...state, eventId: value }));
        setErrorMessage((state) => ({ ...state, billRateText: EMPTY }));
        setErrorMessage((state) => ({ ...state, currencyText: EMPTY }));
       // setSaveDisabled(false);
      }
    } else {
      if (eventId === "currency" && !contingentWorker.billRate) {
        setError(true);
        setErrorMessage((state) => ({ ...state, billRateText: REQUIRED }));
        setSaveDisabled(true);
      } else if(contingentWorker.billRate==0){
        setError(true);
        setErrorMessage((state) => ({ ...state, billRateText: BILLRATE_REQUIRES}));
        setSaveDisabled(true);
      } else if (eventId === "billRate" && !contingentWorker.currency) {
        setError(true);
        setErrorMessage((state) => ({ ...state, currencyText: REQUIRED }));
        setSaveDisabled(true);
      } else {
        setErrorMessage((state) => ({ ...state, billRateText: EMPTY }));
        setErrorMessage((state) => ({ ...state, currencyText: EMPTY }));
       // setSaveDisabled(false);
      }
    }
  };

  const handleManagerChange = (event, newValue) => {
    if (newValue && newValue !== null) {
      setContingentWorker((state) => ({ ...state, manager: newValue }));
      setErrorMessage((state) => ({ ...state, manager: EMPTY }));
      if(worker && isEmptyObject(worker)){
      let managerId = newValue.managerId ? newValue.managerId : user.workerId;
       updateCostCenter(managerId);
      }
    } else {
      const value = event.target.value;
      if (!value) {
        setContingentWorker((state) => ({ ...state, manager: EMPTY }));
        setErrorMessage((state) => ({ ...state, manager: REQUIRED }));
      }
    }
  };

  const handleDelegateManagerChange = (event, newValue) => {
    if (newValue && newValue !== null) {
      let idArray = [];
      newValue.forEach((item) => idArray.push(item.managerId));
      setContingentWorker((state) => ({ ...state, approvingManager: idArray }));
    }
  };

  const enableAlternateCountry = (country) => {
    if (
      country &&
      altCountryAccessCountries &&
      altCountryAccessCountries.includes(country)
    ) {
      setAltCountryEnabled(true);
    }
  };

  const handleAltCountryChange = (event, newValue) => {
    if (newValue || newValue === null) {
      setContingentWorker((state) => ({
        ...state,
        alternateCountry: newValue,
      }));
      setErrorMessage((state) => ({ ...state, alternateCountry: EMPTY }));
    }
  };

  //isFormValid is called when there is any field change
  useEffect(() => {
    isFormValid();
  }, [contingentWorker, workerRoles, isDirty, showBillRate]);

  const isPermWorker = worker && worker.workerType === "employee";
  const isBeelineWorker = worker && worker.createdBy === "beeline";
  const isFormValid = () => {
    const validWorkerRoles = validateWorkerRoles();
    if (
      (isPermWorker ||
        (!isPermWorker &&
          ((KILL_CWK_AUTO && contingentWorker.employeeId) || !KILL_CWK_AUTO) &&
          contingentWorker.firstName &&
          contingentWorker.lastName &&
          contingentWorker.manager &&
          contingentWorker.jobRole &&
          contingentWorker.agency &&
          (contingentWorker.costCenter ) &&
          (contingentWorker.product ) &&
          (contingentWorker.function ) &&
          (showBillRate ? contingentWorker.currency && contingentWorker.billRate : true) &&
          ((KILL_CWK_AUTO && contingentWorker.country) || !KILL_CWK_AUTO))) &&
      validWorkerRoles
    ) {
      setSaveDisabled(false);

      setError(false);
      // if (contingentWorker.currency || contingentWorker.billRate) {
      //   if (contingentWorker.currency && !contingentWorker.billRate)
      //     setSaveDisabled(true);
      //   if (!contingentWorker.currency && contingentWorker.billRate)
      //     setSaveDisabled(true);
      // }
     } else {
      setError(true);
      setSaveDisabled(true);
    }
  };

  const isMgrWorker =
    worker && worker.isManager && worker.workerType === "employee";

  const handleSave = async (
    workerscheduleData,
    gdeReceivedData,
    transportRecievedData,
    sbsDataAfterSubmit,
    crozierDataAfterSubmit,
    imTimeAccessDataAfterSubmit,
    gorpaAccessDataAfterSubmit,
    smartSortUserDataAfterSubmit,
    securebaseDataAfterSubmit,
  ) => {
    setIsSaving(true);
    setNewWorkerId("");
    let error = isError;
    //Email Validation
    if (contingentWorker[EMAIL]) {
      const emailError = await validateEmail(contingentWorker[EMAIL]);
      error = error || emailError;
    }

    if (contingentWorker[EMPLOYEE_ID] && KILL_CWK_AUTO) {
      const employeeID = contingentWorker[EMPLOYEE_ID];
      if (!NUMBER_RE.test(employeeID)) {
        error = true;
        setError(error);
        setErrorMessage((state) => ({ ...state, employeeId: INCORRECT_ENTRY }));
      }
    }

    const workerRolesToUpdate = [];
    if (validateWorkerRoles()) {
      console.log(">>> Valid worker Roles");
      const systems = regions.systems;
      if (systems && systems.length > 0) {
        for (let i = 0; i < systems.length; i++) {
          const system = systems[i];
          const currentRegions = workerRoles && workerRoles[system] ? Object.keys(workerRoles[system]) : [];
          if (currentRegions.length > 0) {
            const accessDetails = workerRoles[system];
            currentRegions.forEach((region) => {
              if (
                accessDetails[region] &&
                accessDetails[region].userId &&
                accessDetails[region].userId !== "" &&
                accessDetails[region].userId !== null
              ) {
               if(accessDetails[region].role == undefined || accessDetails[region].role == null)
                {
                  delete accessDetails[region].role;
                }
                workerRolesToUpdate.push(accessDetails[region]);
              }
            });
          }
        }
        console.log(">>> workerRolesToUpdate", workerRolesToUpdate);
      }
    } else {
      console.log(">>> Invalid worker Roles");
      error = true;
    }
    if (!error) {
      if (!isEmptyObject(imTimeAccessDataAfterSubmit)) {
        if (imTimeAccessDataAfterSubmit.role != "Worker" && !isApprover) {
          setIsApprover(true);
          contingentWorker.isApprover = true;
          // setContingentWorker((state) => ({ ...state, [IS_APPROVER]: true }));
          setErrorMessage((state) => ({ ...state, [IS_APPROVER]: EMPTY }));
        } else if (
          imTimeAccessDataAfterSubmit.role === "Worker" &&
          isApprover
        ) {
          setIsApprover(false);
          contingentWorker.isApprover = false;
        }
      } else {
        imTimeAccessDataAfterSubmit = null;
      }
      contingentWorker.isApprover = contingentWorker.hasOwnProperty(
        "isApprover"
      )
        ? contingentWorker.isApprover
        : false;
      contingentWorker.timezone = contingentWorker.timezone ? contingentWorker.timezone : {};
      let tempWorker = getWorker(contingentWorker);
      const actionTS = new Date().toISOString();
      tempWorker.actionTS = actionTS;
      if (isAuthenticated && user && (user.isManager || user.isApprover)) {
        tempWorker.actionBy = user.workerId;
      } else {
        tempWorker.actionType = PENDING;
      }
      if (!isEmptyObject(workerscheduleData)) {
        workerscheduleData.actionBy = tempWorker.actionBy;
        workerscheduleData.actionTS = tempWorker.actionTS;
      }

      if (!isEmptyObject(gdeReceivedData)) {
        gdeReceivedData.actionBy = tempWorker.actionBy;
        gdeReceivedData.actionTS = tempWorker.actionTS;
        gdeReceivedData.activityFamilyId = "gde";
      } else {
        gdeReceivedData = null;
      }

      if (!isEmptyObject(transportRecievedData)) {
        transportRecievedData.actionBy = tempWorker.actionBy;
        transportRecievedData.actionTS = tempWorker.actionTS;
        transportRecievedData.activityFamilyId = "transportation";
        tempWorker.isTransportation = transportRecievedData.isActive;
      } else {
        transportRecievedData = null;
      }

      if (!isEmptyObject(imTimeAccessDataAfterSubmit)) {
        imTimeAccessDataAfterSubmit.actionBy = tempWorker.actionBy;
        imTimeAccessDataAfterSubmit.actionTS = tempWorker.actionTS;
      }
      let gorpaFinalData = {};
      if(!isEmptyObject(gorpaAccessDataAfterSubmit)){
        gorpaAccessDataAfterSubmit.actionBy = tempWorker.actionBy;
        gorpaAccessDataAfterSubmit.actionTS = tempWorker.actionTS;
        gorpaFinalData = {...gorpaAccessDataAfterSubmit};
      }
      else{
        gorpaAccessDataAfterSubmit=null;
      }
      let sbsFinalData = {};
      if (!isEmptyObject(sbsDataAfterSubmit)) {
        sbsDataAfterSubmit.actionBy = tempWorker.actionBy;
        sbsDataAfterSubmit.actionTS = tempWorker.actionTS;
        sbsDataAfterSubmit.activityFamilyId = "SBS";
        sbsFinalData = { ...sbsDataAfterSubmit };
        const selectedSBSDistricts = sbsFinalData.sbsDistricts;
        const selectedSBSBuildings = sbsFinalData.sbsBuildings;
        const districts = selectedSBSDistricts.map((record) => record.district);
        sbsDataAfterSubmit.sbsDistricts = districts;
        const finalBuildings = [];
        districts.forEach((districtId) => {
          selectedSBSBuildings.forEach((buildingId) => {
            if (Object.keys(sbsDistBuilingMap).length > 0) {
              if (
                sbsDistBuilingMap[districtId] &&
                sbsDistBuilingMap[districtId][buildingId]
              ) {
                finalBuildings.push(sbsDistBuilingMap[districtId][buildingId]);
              }
            }
          });
        });
        sbsDataAfterSubmit.sbsBuildings = finalBuildings;
        // tempWorker.isSbs = sbsDataAfterSubmit.isActive;
      } else {
        sbsDataAfterSubmit = null;
      }

      let securebaseFinalData = {};
      if (!isEmptyObject(securebaseDataAfterSubmit)) {
        securebaseDataAfterSubmit.actionBy = tempWorker.actionBy;
        securebaseDataAfterSubmit.actionTS = tempWorker.actionTS;
        securebaseDataAfterSubmit.activityFamilyId = "SECUREBASE";
        securebaseFinalData = { ...securebaseDataAfterSubmit };
        const selectedSecurebaseDistricts = securebaseFinalData.sbDistricts;
        const selectedSecurebaseBuildings = securebaseFinalData.sbBuildings;
        const districts = selectedSecurebaseDistricts.map((record) => record.district);
        securebaseDataAfterSubmit.sbDistricts = districts;
        const finalBuildings = [];
        districts.forEach((districtId) => {
          selectedSecurebaseBuildings.forEach((buildingId) => {
            if (Object.keys(securebaseDistBuilingMap).length > 0) {
              if (
                securebaseDistBuilingMap[districtId] &&
                securebaseDistBuilingMap[districtId][buildingId]
              ) {
                finalBuildings.push(securebaseDistBuilingMap[districtId][buildingId]);
              }
            }
          });
        });
        securebaseDataAfterSubmit.sbBuildings = finalBuildings;
        // tempWorker.isSbs = securebaseDataAfterSubmit.isActive;
      } else {
        securebaseDataAfterSubmit = null;
      }
      
      let smartSortUserFinalData = {};
      if (!isEmptyObject(smartSortUserDataAfterSubmit)) {
        smartSortUserDataAfterSubmit.actionBy = tempWorker.actionBy;
        smartSortUserDataAfterSubmit.actionTS = tempWorker.actionTS;
        smartSortUserDataAfterSubmit.activityFamilyId = "ONEIL";
        smartSortUserFinalData = { ...smartSortUserDataAfterSubmit };
        //new code
        
        const selectedSmartSortDistricts = smartSortUserFinalData.onlDistricts;
        console.log("selectedSmartSortDistricts",selectedSmartSortDistricts);
        const districts = selectedSmartSortDistricts.map((record) => record.district);
        smartSortUserDataAfterSubmit.onlDistricts = districts;

        const selectedSmartSortBuildings = smartSortUserFinalData.onlBuildings;
        const finalSmartSortBuildings = [];
        // selectedSmartSortBuildings.forEach((buildingId) => {
        //   finalSmartSortBuildings.push(buildingId);

        // });
        districts.forEach((districtId) => {
          selectedSmartSortBuildings.forEach((buildingId) => {
            if (Object.keys(smartSortDistBuilingMap).length > 0) {
              if (
                smartSortDistBuilingMap[districtId] &&
                smartSortDistBuilingMap[districtId][buildingId]
              ) {
                finalSmartSortBuildings.push(smartSortDistBuilingMap[districtId][buildingId]);
              }
            }
          });
        });
        smartSortUserDataAfterSubmit.onlBuildings = finalSmartSortBuildings;
        
        smartSortUserDataAfterSubmit.isActive = smartSortUserFinalData.isActive;
        smartSortUserDataAfterSubmit.userId = smartSortUserFinalData.userId.toUpperCase();
      } else {
        smartSortUserDataAfterSubmit = null;
      }
      let crozierFinalData = {};
      if (!isEmptyObject(crozierDataAfterSubmit)) {
        crozierDataAfterSubmit.actionBy = tempWorker.actionBy;
        crozierDataAfterSubmit.actionTS = tempWorker.actionTS;
        crozierDataAfterSubmit.activityFamilyId = "crozier";
        // tempWorker.isCruzier = crozierDataAfterSubmit.isActive;
        crozierFinalData = { ...crozierDataAfterSubmit };
        const selectedcrozierDistrict = crozierFinalData.crozierDistrict;
        const selectedcrozierBuildings = crozierFinalData.crozierBuildings;
        const districts = selectedcrozierDistrict.map(
          (record) => record.district
        );
        crozierDataAfterSubmit.crozierDistrict = districts;
        const finalBuildings = [];
        districts.forEach((districtId) => {
          selectedcrozierBuildings.forEach((buildingId) => {
            if (Object.keys(crozierDistBuilingMap).length > 0) {
              if (
                crozierDistBuilingMap[districtId] &&
                crozierDistBuilingMap[districtId][buildingId]
              ) {
                finalBuildings.push(
                  crozierDistBuilingMap[districtId][buildingId]
                );
              }
            }
          });
        });
        crozierDataAfterSubmit.crozierBuildings = finalBuildings;
      } else {
        crozierDataAfterSubmit = null;
      }

      if (isEmptyObject(worker)) {
        tempWorker.actionType = ADD;

        if (!isEmptyObject(workerscheduleData))
          workerscheduleData.actionType = tempWorker.actionType;

        // if (!isEmptyObject(gdeReceivedData))
        //   gdeReceivedData.actionType = tempWorker.actionType;

        if (!KILL_CWK_AUTO && user.country) {
          // let mgrCountry = "Australia";
          let mgrCountry = user.country;
          getNewCwkId(mgrCountry)
            .then((result) => {
              let resultArr = result.toString().split(",");
              console.log("NEW CWK ID=== ", resultArr[0].toString());
              tempWorker.workerId = resultArr[0].toString();
              tempWorker.country = user.country;
              tempWorker.countryCode = resultArr[1].toString();
              tempWorker.isNoEmail = isNoEmail;
              if (tempWorker.email === "" && !isPermWorker) {
                tempWorker.email = resultArr[0].toString() + EmailDomain;
                tempWorker.isNoEmail = true;
              }
              console.log("NEW Worker=", tempWorker);
              return addContingentWorker(
                tempWorker,
                workerscheduleData,
                gdeReceivedData,
                transportRecievedData,
                sbsDataAfterSubmit,
                crozierDataAfterSubmit,
                imTimeAccessDataAfterSubmit,
                gorpaAccessDataAfterSubmit,
                smartSortUserDataAfterSubmit,
                securebaseDataAfterSubmit,
              );
            })
            .then((result) => {
              if (result) {
                console.log(
                  "Contingent worker created successfully===",
                  result
                );
                result && setNewWorkerId(result.workerId);
                if (workerRolesToUpdate && workerRolesToUpdate.length > 0) {
                  addWorkerRoles(
                    tempWorker.workerId,
                    workerRolesToUpdate,
                    user.workerId
                  );
                }
                setConfirmationMsg(true);
              } else {
                // setErrorMessage((state) => ({
                //   ...state,
                //   employeeId: INCORRECT_ENTRY,
                // }));
                // setErrorExceptionMsg(true);
                setErrorMsg(true);
              }
              setIsSaving(false);
            })
            .catch((error) => {
              console.log("catch catch error", error);
              // setConfirmationMsg(true);
              //  setErrorMessage((state) => ({
              //    ...state,
              //    firstName: ERROR_WHILE_SAVE,
              //  }));
              setErrorExceptionMsg(true);
              setIsSaving(false);
            });
        } else {
          addContingentWorker(
            tempWorker,
            workerscheduleData,
            gdeReceivedData,
            transportRecievedData,
            sbsDataAfterSubmit,
            crozierDataAfterSubmit,
            imTimeAccessDataAfterSubmit,
            gorpaAccessDataAfterSubmit,
            smartSortUserDataAfterSubmit,
            securebaseDataAfterSubmit
          )
            .then((result) => {
              if (result) {
                if (workerRolesToUpdate && workerRolesToUpdate.length > 0) {
                  addWorkerRoles(
                    tempWorker.workerId,
                    workerRolesToUpdate,
                    user.workerId
                  );
                }
                console.log(
                  "Contingent worker created successfully===",
                  result
                );
                result && setNewWorkerId(result.workerId);
                setConfirmationMsg(true);
              } else {
                console.log("err in addContingentWorker without autoGen.");
                setErrorMessage((state) => ({
                  ...state,
                  employeeId: INCORRECT_ENTRY,
                }));
                setErrorMsg(true);
              }
              setIsSaving(false);
            })
            .catch((error) => {
              console.log(error);
              // setErrorMessage((state) => ({
              //   ...state,
              //   firstName: ERROR_WHILE_SAVE,
              // }));
              setErrorExceptionMsg(true);
              setIsSaving(false);
            });
        }
      } else {
        tempWorker.actionType = EDIT;
        if (!isEmptyObject(workerscheduleData))
          workerscheduleData.actionType = tempWorker.actionType;

        tempWorker.isNoEmail = isNoEmail;
        if (tempWorker.email === "" && !isPermWorker)
          {
            tempWorker.email = tempWorker.workerId + EmailDomain;
            tempWorker.isNoEmail = true;
          }

        editContingentWorker(
          tempWorker,
          workerscheduleData,
          gdeReceivedData,
          transportRecievedData,
          sbsDataAfterSubmit,
          crozierDataAfterSubmit,
          imTimeAccessDataAfterSubmit,
          gorpaAccessDataAfterSubmit,
          smartSortUserDataAfterSubmit,
          securebaseDataAfterSubmit
        )
          .then((result) => {
            if (result) {
              if (workerRolesToUpdate && workerRolesToUpdate.length > 0) {
                addWorkerRoles(
                  tempWorker.workerId,
                  workerRolesToUpdate,
                  user.workerId
                );
              }
              setConfirmationMsg(true);
              setIsSaving(false);
            }
          })
          .catch((error) => {
            console.log(error);
            // setErrorMessage((state) => ({
            //   ...state,
            //   firstName: ERROR_WHILE_SAVE,
            // }));
            setErrorExceptionMsg(true);
            setIsSaving(false);
          });
      }
    } else {
      setIsSaving(false);
    }
  };

  const validateEmail = async (email) => {
    let error = false;
    if (email) {
      const email = contingentWorker[EMAIL];
      if (!MAIL_FORMAT_RE.test(email)) {
        error = true;
        setError(error);
        setErrorMessage((state) => ({ ...state, email: INCORRECT_ENTRY }));
      } else {
        await getDetailsByEmail(email)
          .then((doc) => {
            if (
              doc &&
              (!contingentWorker.employeeId ||
                (contingentWorker.employeeId &&
                  doc.data().workerId != contingentWorker.employeeId))
            ) {
              error = true;
              setError(error);
              setErrorMessage((state) => ({ ...state, email: ALREADY_EXISTS }));
            } else {
              setErrorMessage((state) => ({ ...state, [EMAIL]: EMPTY }));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setErrorMessage((state) => ({ ...state, [EMAIL]: EMPTY }));
    }
    return error;
  };

  const closeModalConfirmationMsg = () => {
    setConfirmationMsg(false);
    if (
      (isAuthenticated && user && (user.isManager || user.isApprover)) ||
      (empId && worker)
    ) {
      // history.push(REVIEW, { isManageWorkers: true });
      history.push(MANAGE_WORKERS, { isManageWorkers: true });
    } else {
      history.push(ROOT);
    }
  };

  const closeModalErrorMsg = () => {
    setErrorExceptionMsg(false);
  };

  const closeModalErrorExceptionMsg = () => {
    setErrorExceptionMsg(false);
  };

  const handleCancel = () => {
    if (
      (isAuthenticated && user && (user.isManager || user.isApprover)) ||
      (empId && worker)
    ) {
      history.push(MANAGE_WORKERS, { isManageWorkers: true });
    } else {
      history.push(ROOT);
    }
  };

  const handleResetPin = () => {
    setContingentWorker((state) => ({ ...state, pin: "" }));
    const tempWorker = getWorker(contingentWorker);
    resetWorkerPin(tempWorker.workerId, "").then((response) => {
      setIsPinReset(response);
    });
  };
 
  
  const labelStyle = 'original'
  const { options : timezoneOptions , parseTimezone } = useTimezoneSelect({ labelStyle, allTimezones })

  const workerMarkup = (
    <>
      <div className={classes.container}>
        {isEmptyObject(worker) ? (
          <>
            <SectionHead
              back={handleCancel}
              name={properCase(t("pgAddWorker.lblAddContingentWorker"))}
            />
            <Alert severity="info" style={{ marginBottom: 16 }}>
              {t("pgAddWorker.lblInfo")}
            </Alert>
          </>
        ) : (
          <>
            <SectionHead
              back={handleCancel}
              name={properCase(t("pgAddWorker.lblEditContingentWorker"))}
            />
          </>
        )}

        <Grid container direction="column" spacing={spacing}>
          <Grid
            container
            item
            alignItems="stretch"
            spacing={spacing}
            justify="space-between"
          >
            <Grid item md={8} xs={12} xm={12} lg={8} xl={8}>
              <Paper className={classes.paper} variant="outlined">
                <Box padding={2}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    spacing={1}
                    className={classes.mainContainer}
                  >
                    {empId ? (
                      <Grid item sm={12} lg={12}>
                        <FormControl className={classes.nameControl}>
                          <Typography
                            variant="subtitle1"
                            className={`${classes.employeeId} ${classes.color}`}
                          >
                            {t("pgAddWorker.lblEmployeeId")}:
                            {empId ? empId : null}
                          </Typography>
                        </FormControl>
                      </Grid>
                    ) : null}
                    <Grid item xs={4}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          id="firstName"
                          name="firstName"
                          defaultValue={worker.firstName}
                          required
                          onBlur={handleInputChange}
                          onChange={handleInputChange}
                          label={t("pgAddWorker.tlFirstName")}
                          error={!!errorMessage.firstName}
                          helperText={errorMessage.firstName}
                          InputProps={{ className: classes.name }}
                          FormHelperTextProps={{
                            className: classes.formHelperText,
                          }}
                          disabled={isPermWorker || isBeelineWorker}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          id="lastName"
                          name="lastName"
                          defaultValue={worker.lastName}
                          onBlur={handleInputChange}
                          onChange={handleInputChange}
                          error={!!errorMessage.lastName}
                          helperText={errorMessage.lastName}
                          required
                          label={t("pgAddWorker.tlLastName")}
                          InputProps={{ className: classes.name }}
                          FormHelperTextProps={{
                            className: classes.formHelperText,
                          }}
                          disabled={isPermWorker || isBeelineWorker}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={4} >
                      <FormControl required className={classes.formControl}>
                      <Autocomplete
                            options={timezoneOptions}
                            getOptionLabel={(prop)=> prop.label}
                            fullWidth
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "timezone",
                                  value: v ? parseTimezone(v.value) : {},
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.timezone")}
                                id="timezone"
                                name="timezone"
                                error={errorMessage.timezone ? true : false}
                                helperText={errorMessage.timezone}
                              />
                            )}
                            value={contingentWorker.timezone}
                            disabled={isPermWorker}
                          />
                      </FormControl>

                    </Grid>
                    <Grid item xs={4}>
                      <Grid item>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="email"
                            name="email"
                            defaultValue={worker.email}
                            onBlur={handleEmailChange}
                            onChange={handleInputChange}
                            error={!!errorMessage.email}
                            helperText={errorMessage.email}
                            // required
                            label={t("pgAddWorker.tlEmail")}
                            InputProps={{ className: classes.color }}
                            FormHelperTextProps={{
                              className: classes.formHelperText,
                            }}
                            disabled={isPermWorker || isNoEmail}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <FormControl
                          className={`${classes.cbControl} ${classes.color}`}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                style={{ paddingLeft: 20 }}
                                color="primary"
                                checked={isNoEmail}
                                onChange={handleInputChange}
                                id="isNoEmail"
                                name="isNoEmail"
                                disabled={isPermWorker}
                              />
                            }
                            label={t("other.lblNoEmail")}
                          //label={t("No Email")}
                          />
                        </FormControl>
                      </Grid>

                    </Grid>
                      <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                          <TextField
                            id="phone"
                            name="phone"
                            defaultValue={worker.phone}
                            onBlur={handleInputChange}
                            onChange={handleInputChange}
                            error={!!errorMessage.phone}
                            helperText={errorMessage.phone}
                            // required
                            label={t("pgAddWorker.tlPhone")}
                            // InputProps={{ className: classes.color }}
                            FormHelperTextProps={{
                              className: classes.formHelperText,
                            }}
                            value={contingentWorker.phone}
                            disabled={isPermWorker}
                          />
                        </FormControl>
                        {!isPermWorker && (
                        <FormControl className={classes.formControl} style={{marginTop: '8px'}}>
                          <Autocomplete
                            options={jobTypeOptions}
                            getOptionLabel={(option) => option}
                            fullWidth
                            defaultValue={contingentWorker.jobType}
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "jobType",
                                  value: v ? v: "",
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.jobType")}
                                id="jobType"
                                name="jobType"
                              />
                            )}
                          />
                        </FormControl>
                        )}
                      </Grid>

                      <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                          <Autocomplete
                            options={jobDepartmentOptions}
                            getOptionLabel={(option) => option}
                            fullWidth
                            defaultValue={contingentWorker.jobDepartment ? contingentWorker.jobDepartment : OPERATIONS}
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "jobDepartment",
                                  value: v ? v: "",
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.lblJobDepartment")}
                                id="jobDepartment"
                                name="jobDepartment"
                                // error={errorMessage.jobDepartment ? true : false}
                                // helperText={errorMessage.jobDepartment}
                              />
                            )}
                            disabled={isPermWorker}
                          />
                        </FormControl>
                        <FormControl className={classes.formControl} style={{marginTop: "8px"}}>
                          <Autocomplete
                            options={jobRoles}
                            getOptionLabel={(option) => option.label}
                            fullWidth
                            // onBlur={handleJobRoleChange}
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "jobRole",
                                  value: v ? v.value : "",
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.jobRole")}
                                id="jobRole"
                                required
                                name="jobRole"
                                // onBlur={handleJobRoleChange}
                                error={errorMessage.jobRole ? true : false}
                                helperText={errorMessage.jobRole}
                              />
                            )}
                            value={{
                              label: getJobRole(
                                jobRoles,
                                contingentWorker.jobRole
                              ),
                            }}
                            disabled={isPermWorker}
                          />
                        </FormControl>
                      </Grid>
                    <Grid item xs={4}>
                      <FormControl className={classes.formControl}>
                        <ManagerLookup
                          onChangeFunction={handleManagerChange}
                          errorMessage={errorMessage}
                          disabled={isPermWorker || isBeelineWorker}
                          mgrId={
                            !isEmptyObject(approveForMgr)
                              ? approveForMgr.managerId
                              : isEmptyObject(worker)
                                ? user.workerId
                                : worker.managerId
                          }
                        ></ManagerLookup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={isPermWorker ? 7 : 4}>
                      <FormControl className={classes.formControl} style={{maxWidth:'232px'}}>
                        <DelegateManager
                          onChangeFunction={handleDelegateManagerChange}
                          id={worker.approvingManager}
                          empId={empId}
                          managerLookupDefaultValue={
                            !isEmptyObject(approveForMgr)
                              ? approveForMgr.managerId
                              : isEmptyObject(worker)
                                ? user.workerId
                                : worker.managerId
                          }
                        />
                      </FormControl>
                    </Grid>
                     {!isPermWorker && (
                       <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                          <Autocomplete
                            options={costCenterOptions}
                            getOptionLabel={(option) => option.costCenter}
                            value={contingentWorker ? {
                              'costCenter':contingentWorker.costCenter,
                              'id':contingentWorker.costCenterId
                            } : {}}
                            fullWidth
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "costCenter",
                                  value: v ? v : ""
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.costCenter")}
                                id="costCenter"
                                required
                                name="costCenter"
                                helperText={errorMessage.costCenter}
                                error={!!errorMessage.costCenter}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                              />
                            )}
                          />
                        </FormControl>
                        </Grid>
                      )}
                      {isAltCountryEnabled && (
                      <>
                        <Grid item xs={4}>
                          <FormControl className={classes.formControl}>
                            <TextField
                              id="country"
                              name="country"
                              defaultValue={
                                worker && worker.country
                                  ? worker.country
                                  : !isEmptyObject(approveForMgr)
                                    ? approveForMgr.managerCountry
                                    : user.country
                              }
                              label={t("other.tlCountry")}
                              InputProps={{ className: classes.name }}
                              FormHelperTextProps={{
                                className: classes.formHelperText,
                              }}
                              disabled={true}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={4}>
                          <FormControl className={classes.formControl}>
                            <CountryLookup
                              onChangeFunction={handleAltCountryChange}
                              filterCountry={
                                !isEmptyObject(approveForMgr)
                                  ? approveForMgr.managerCountry
                                  : isEmptyObject(worker)
                                    ? user.country
                                    : worker.country
                              }
                              countryCode={
                                !isEmptyObject(worker) &&
                                worker.alternateCountryCode
                              }
                            ></CountryLookup>
                          </FormControl>
                        </Grid>
                      </>
                    )}
                    {!isPermWorker && (
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                          <Autocomplete
                            options={productOptions}
                            getOptionLabel={(option) => option.product}
                            value={contingentWorker ? {
                              'product':contingentWorker.product,
                              'id':contingentWorker.productId
                            } : {}}
                            fullWidth
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "product",
                                  value: v ? v : ""
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.lblproduct")}
                                id="product"
                                required
                                name="product"
                                error={!!errorMessage.product}
                                helperText={errorMessage.product}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                              />
                            )}
                          />
                        </FormControl>
                        </Grid>
                    )}
                    {isAltCountryEnabled && (
                      <>
                        <Grid item xs={4}>
                        <FormControl className={classes.formControl} style={{maxWidth: "100px"}}>
                          <Autocomplete
                           id="operationalDistrict"
                            options={operationalDistricts}
                            getOptionLabel={(option) => option.district?option.district:option}
                            fullWidth
                            value={contingentWorker.operationalDistrict}
                            getOptionSelected = {
                              (option, value) => option === value 
                              || option.district === value
                              || option.district === value.district
                            }
                            multiple={true}
                            onChange={(e, newValue) => {
                              console.log("operationalDistrict", newValue)
                              let selectedValues = [];
                              newValue && Array.isArray(newValue) && newValue.length > 0 && newValue.forEach(record => {
                                if(typeof record === "string"){
                                  selectedValues.push(record);
                                }else{
                                  if(record.district){
                                    selectedValues.push(record.district);
                                  }
                                }
                              })
                              handleInputChange({
                               target: {
                                      id: "operationalDistrict",
                                      value: selectedValues ? selectedValues : []
                                    },
                                  })  
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.lblOperationalDistrict")}
                                id="operationalDistrict"
                                name="operationalDistrict"
                                error={!!errorMessage.operationalDistrict}
                                helperText={errorMessage.operationalDistrict}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                              />
                            )}
                          
                          />
                        </FormControl>
                        </Grid>

                        <Grid item xs={4}>
                        <FormControl className={classes.formControl} style={{maxWidth: "100px"}}>
                          <Autocomplete
                            options={operationalBuildings}
                            id="operationalBuilding"
                            getOptionLabel={(option) => option}
                            fullWidth
                            value={contingentWorker.operationalBuilding}
                            multiple={true}
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "operationalBuilding",
                                  value: v ? v : []
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.lblOperationalBuilding")}
                                id="operationalBuilding"
                                name="operationalBuilding"
                                error={!!errorMessage.operationalBuilding}
                                helperText={errorMessage.operationalBuilding}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                              />
                            )}
                          />
                        </FormControl>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={4}>
                      {!isPermWorker && (
                      <FormControl className={classes.formControl}>
                          <Autocomplete
                            options={functionOptions}
                            getOptionLabel={(option) => option.function}
                            fullWidth
                            defaultValue={{
                              'function':contingentWorker.function,
                              'id':contingentWorker.functionId
                            }}
                            onChange={(e, v) =>
                              handleInputChange({
                                target: {
                                  id: "function",
                                  value: v ? v : ""
                                },
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={t("other.lblfunction")}
                                id="function"
                                required
                                name="function"
                                error={!!errorMessage.function}
                                helperText={errorMessage.function}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                              />
                            )}
                          />
                        </FormControl>
                    )}
                    </Grid>
                    {!isPermWorker && (
                      <>
                          <Grid item xs={4}>
                            <FormControl className={classes.formControl}>
                              <TextField
                                id="agency"
                                name="agency"
                                defaultValue={worker.agency}
                                onBlur={handleInputChange}
                                onChange={handleInputChange}
                                required
                                error={!!errorMessage.agency}
                                helperText={errorMessage.agency}
                                label={t("pgAddWorker.tlAgency")}
                                // InputProps={{ className: classes.color }}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                                value={contingentWorker.agency}
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={4}>
                            <FormControl className={classes.formControl}>
                              <TextField
                                id="otherId"
                                name="otherId"
                                defaultValue={worker.otherId}
                                onBlur={handleInputChange}
                                onChange={handleInputChange}
                                error={!!errorMessage.otherId}
                                helperText={errorMessage.otherId}
                                label={t("pgAddWorker.tlOtherId")}
                                disabled={isBeelineWorker}
                                style={{width:"235px"}}
                                InputProps={{ className: classes.color }}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                                value={contingentWorker.otherId}
                              />
                            </FormControl>
                          </Grid>


                            {showBillRate && (
                              <>
                              <Grid item xs={4}>
                            <FormControl className={classes.formControl} style={{minWidth:"235px"}}>
                              <TextField
                                id="billRate"
                                name="billRate"
                                required
                                type="number"
                                label={t("other.tlHourlyBillRate")}
                                onBlur={handleBillRateCurrencyChange}
                                onChange={handleInputChange}
                                error={!!errorMessage.billRateText}
                                helperText={errorMessage.billRateText}
                                defaultValue={worker.billRate}
                                disabled={isBeelineWorker}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                    className: classes.name,
                                  },
                                }}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                                onKeyDown={(evt) =>
                                  ["-", "+", "e", "E"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                value={contingentWorker.billRate}
                              ></TextField>
                            </FormControl>
                          </Grid>
                          </>
                    )}
                    </>
                    )}
                    <Grid container direction="row">
                          {empId && isEmptyObject(worker) ? (
                        <Grid item xs={12} style={{ height: 60 }} />
                      ) : (
                        <>
                          <Grid item xs={4}>
                            <FormControl
                              className={`${classes.cbControl} ${classes.color}`}
                            >
                              <FormControlLabel
                                labelPlacement="start"
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={isActiveWorker}
                                    onChange={handleInputChange}
                                    id="isActiveWorker"
                                    name="isActiveWorker"
                                    disabled={isPermWorker || isBeelineWorker}
                                  />
                                }
                                label={t("pgAddWorker.lblIsActive")}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl
                              className={`${classes.cbControl} ${classes.color}`}
                            >
                              <FormControlLabel
                                labelPlacement="start"
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={isApprover}
                                    onChange={handleInputChange}
                                    id="isApprover"
                                    name="isApprover"
                                    // disabled={worker.isManager}
                                    disabled={isMgrWorker}
                                  />
                                }
                                label={t("other.pgAddWorkerIsManager")}
                              />
                            </FormControl>
                          </Grid>
                        </>
                      )}
                    
                    {!isPermWorker && showBillRate && (
                      <>
                      <Grid item sm={2} style={{maxWidth:"190px",minWidth:"100px", paddingTop:"5px", marginLeft: "4px"}}>
                       <FormControl className={classes.formControl}>
                         <Autocomplete
                           defaultValue={{
                             currency_code: worker.currency
                               ? worker.currency
                               : "",
                           }}
                           id="currency"
                           options={distinctCurrencyData}
                           disabled={isBeelineWorker}
                           getOptionLabel={(option) =>
                             option.currency_code
                           }
                           onBlur={handleBillRateCurrencyChange}
                           onChange={(e, v) =>
                             handleInputChange({
                               target: {
                                 id: "currency",
                                 value: v ? v.currency_code : "",
                               },
                             })
                           }
                           renderInput={(params) => (
                             <TextField
                               {...params}
                               variant="standard"
                               label={t("other.tlCurrency")}
                               required
                               id="Currency"
                               name="Currency"
                               style={{width:"240px"}}
                               onBlur={handleBillRateCurrencyChange}
                               error={!!errorMessage.currencyText}
                               helperText={errorMessage.currencyText}
                             />
                           )}
                         // value={contingentWorker.currencies[0]}
                         />
                       </FormControl>
                     </Grid>
                     </>
                    )}
                   </Grid>
                    <Grid container direction="row">
                      <Grid item xs={2} style={{ marginTop: 15 }}>
                        {isResetPinVisible ? (
                          <Button
                            color="primary"
                            variant="text"
                            disabled={isResetPinDisabbled}
                            // className={classes.button}
                            onClick={handleResetPin}
                          >
                            {t("other.tlResetPin")}
                          </Button>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
            <Grid item md={4} xs={12} xm={12} lg={4} xl={4}>
              <Paper className={classes.paper} variant="outlined">
                <Box padding={2}>
                  <FormProvider {...methods}>
                    <LoaderView loading={isScheduleLoading}>
                      <form>
                        <WorkerSchedule initialValue={workingHourData} />
                      </form>
                    </LoaderView>
                  </FormProvider>
                </Box>
              </Paper>
            </Grid>
          </Grid>
          <Grid
            container
            item
            alignItems="stretch"
            spacing={spacing}
            justify="space-between"
          >
            {user.country && (
              <>
              <Grid container spacing={1} direction="row" item md={3} xs={12} xm={12} lg={3} xl={3}>
              <Grid item xs={12}>
                <Paper className={classes.paper} variant="outlined">
                  <Box padding={2}>
                    <FormProvider {...methods}>
                      <LoaderView loading={isIMtimeDataLoading}>
                        <form>
                          <ImtRoleAccess
                            setIsIMtimeWorker={setIsIMtimeWorker}
                            selectedWorker={location.state}
                            manager={user}
                            setIMtimeValid={setIMtimeValid}
                            initialValue={imTimeRoleData}
                          />
                        </form>
                      </LoaderView>
                    </FormProvider>
                  </Box>
                </Paper>
                </Grid>
                <Grid item xs={12}>
                <Paper className={classes.paper} variant="outlined">
                <Box padding={2}>
                    <FormProvider {...methods}>
                      <LoaderView loading={isGorpaDataLoading}>
                        <form>
                          <GorpaAccess
                            setIsGorpaWorker={setIsGorpaWorker}
                            selectedWorker={location.state}
                            manager={user}
                            setGorpaValid={setGorpaValid}
                            initialValue={gorpaRoleData}
                          />
                        </form>
                      </LoaderView>
                    </FormProvider>
                  </Box>
                </Paper>
              </Grid>
              </Grid>
              </>
            )}

            {warehouseCountries &&
              user.country &&
              warehouseCountries.includes(user.country.toLowerCase()) && (
                <Grid item md={6} xs={12} xm={12} lg={6} xl={6}>
                  <Paper className={classes.paper} variant="outlined">
                    <Box padding={2}>
                      <Grid container direction="row">
                        <Grid item xs={12} key="userAccess">
                          <LoaderView loading={isWarehouseDataLoading}>
                            <UserAccess
                              regions={regions}
                              workerRoles={workerRoles}
                              setWorkerRoles={setWorkerRoles}
                              selectedRegion={selectedRegion}
                              setSelectedRegion={setSelectedRegion}
                              validateWorkerRoles={validateWorkerRoles}

                            />
                          </LoaderView>
                        </Grid>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>
              )}
            {user.country && (
              <Grid item md={3} xs={12} xm={12} lg={3} xl={3}>
                <Paper className={classes.paper} variant="outlined">
                  <Box padding={2}>
                    <FormProvider {...methods}>
                      <LoaderView loading={isSmartSortDataLoading}>
                        <form>
                          <SmartSortUser
                            setIsSmartSortWorker={setIsSmartSortWorker}
                            selectedWorker={location.state}
                            manager={user}
                            initialValue={smartSortUserData}
                            setSmartSortValid={setSmartSortValid}
                            setSmartSortDistBuilingMap={setSmartSortDistBuilingMap}
                            smartSortDistBuilingMap={smartSortDistBuilingMap}
                          />
                        </form>
                      </LoaderView>
                    </FormProvider>
                  </Box>
                </Paper>
              </Grid>
            )}
            <Grid
              container
              item
              alignItems="stretch"
              spacing={spacing}
              justify="flex-start"
            >
              {warehouseCountries &&
                user.country &&
                warehouseCountries.includes(user.country.toLowerCase()) && (
                  <Grid item md={3} xs={12} xm={12} lg={3} xl={3}>
                    <Paper className={classes.paper} variant="outlined">
                      <Box padding={2}>
                        <FormProvider {...methods}>
                          <LoaderView loading={isGdeLoading}>
                            <form
                              onSubmit={methods.handleSubmit((data) =>
                                console.log("data gde ", data)
                              )}
                            >
                              <GdeUserAccess
                                setIsWorkerGde={setIsWorkerGde}
                                selectedWorker={location.state}
                                manager={user}
                                initialValue={gdeData}
                                setGdeValid={setGdeValid}
                              />
                            </form>
                          </LoaderView>
                        </FormProvider>
                      </Box>
                    </Paper>
                  </Grid>
                )}
              {user.country && (
                <Grid item md={2} xs={12} xm={12} lg={2} xl={2}>
                  <Paper className={classes.paper} variant="outlined">
                    <Box padding={2}>
                      <FormProvider {...methods}>
                        <LoaderView loading={isSBSDataLoading}>
                          <form>
                            <SBSUserAccess
                              setIsSbsWorker={setIsSbsWorker}
                              selectedWorker={location.state}
                              manager={user}
                              initialValue={sbsData}
                              setSbsValid={setSbsValid}
                              setSbsDistBuilingMap={setSbsDistBuilingMap}
                              sbsDistBuilingMap={sbsDistBuilingMap}
                            />
                          </form>
                        </LoaderView>
                      </FormProvider>
                    </Box>
                  </Paper>
                </Grid>
              )}
              <Grid item md={2} xs={12} xm={12} lg={2} xl={2}>
                <Paper className={classes.paper} variant="outlined">
                  <Box padding={2}>
                    <FormProvider {...methods}>
                      <LoaderView loading={isCrozierDataLoading}>
                        <form>
                          <CrozierUserAccess
                            setIsCrozierWorker={setIsCrozierWorker}
                            selectedWorker={location.state}
                            manager={user}
                            initialValue={crozierData}
                            setCrozierValid={setCrozierValid}
                            setCrozierDistBuilingMap={setCrozierDistBuilingMap}
                            crozierDistBuilingMap={crozierDistBuilingMap}
                          />
                        </form>
                      </LoaderView>
                    </FormProvider>
                  </Box>
                </Paper>
              </Grid>
              {user.country && (
                <Grid item md={2} xs={12} xm={12} lg={2} xl={2}>
                  <Paper className={classes.paper} variant="outlined">
                    <Box padding={2}>
                      <FormProvider {...methods}>
                        <LoaderView loading={isSecurebaseDataLoading}>
                          <form>
                            <SecurebaseUserAccess
                              setIsSecurebaseWorker={setIsSecurebaseWorker}
                              selectedWorker={location.state}
                              manager={user}
                              initialValue={securebaseData}
                              setSecurebaseValid={setSecurebaseValid}
                              setSecurebaseDistBuilingMap={setSecurebaseDistBuilingMap}
                              securebaseDistBuilingMap={securebaseDistBuilingMap}
                            />
                          </form>
                        </LoaderView>
                      </FormProvider>
                    </Box>
                  </Paper>
                </Grid>
              )}
              {user.country && (
                <Grid item md={3} xs={12} xm={12} lg={3} xl={3}>
                  <Paper className={classes.paper} variant="outlined">
                    <Box padding={2}>
                      <FormProvider {...methods}>
                        <LoaderView loading={isTransportDataLoading}>
                          <form>
                            <TransportUserAccess
                              setIsTransportWorker={setIsTransportWorker}
                              selectedWorker={location.state}
                              manager={user}
                              initialValue={transportData}
                              setTransportValid={setTransportValid}
                            />
                          </form>
                        </LoaderView>
                      </FormProvider>
                    </Box>
                  </Paper>
                </Grid>
              )}
            </Grid>

          </Grid>

          <Grid
            container
            direction="row"
            justify="flex-end"
            spacing={2}
            className={classes.actions}
          >
            <Grid item>
              <Button
                color="primary"
                variant="outlined"
                // className={classes.button}
                onClick={handleCancel}
              >
                {t("pgAddWorker.btnCancel")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={
                  saveDisabled ||
                  isSaving ||
                  isScheduleLoading ||
                  !isValid ||
                  isGdeLoading ||
                  !gdeValid ||
                  isTransportDataLoading ||
                  !transportValid ||
                  isSBSDataLoading ||
                  !sbsValid ||
                  isSecurebaseDataLoading ||
                  !securebaseValid ||
                  isCrozierDataLoading ||
                  !crozierValid ||
                  !iMtimeValid ||
                  isIMtimeDataLoading ||
                  !GorpaValid ||
                  isGorpaDataLoading ||
                  !smartSortValid ||
                  isSmartSortDataLoading ||
                  isWarehouseDataLoading

                }
                // onClick={handleSave}
                onClick={handleSubmit((data) => {
                  console.log(
                    "worker schedule Data",
                    data,
                    "workingHourData",
                    workingHourData
                  );

                  const gdeDataAfterSubmit = {};
                  console.log("isWorkerGde", isWorkerGde, isGdeEdit, data);
                  if (isWorkerGde || isGdeEdit) {
                    gdeDataAfterSubmit.isActive = data.isActive;
                    gdeDataAfterSubmit.country = data.gdeCountry;// convert string to array;
                    gdeDataAfterSubmit.gdeRole = data.gdeRole;
                    gdeDataAfterSubmit.pinActive = data.pinActive;
                    gdeDataAfterSubmit.additionalPermissions = gdePermissionOpts.filter(act => act.role === data.gdeRole).map(act =>{
                      if(act){
                      let actDetails = {...act};
                      if(data.gdePermissions && data.gdePermissions.length>0 &&
                        data.gdePermissions.filter(ele => ele.value === act.value).length>0){
                          actDetails.enabled = true;
                        }
                        return actDetails;
                      }
                    });

                  }

                  delete data.isActive;
                  delete data.gdeCountry;
                  delete data.gdeRole;
                  delete data.pinActive;
                  delete data.gdePermissions;

                  const transportDataAfterSubmit = {};
                  if (isTransportWorker) {
                    transportDataAfterSubmit.isActive = data.isTransportActive;
                    transportDataAfterSubmit.districtRestricted =
                      data.districtRestricted;
                    transportDataAfterSubmit.role = data.transportRole;
                    transportDataAfterSubmit.trDistricts =
                      data.transportDistrict;

                    if (
                      data.transportRole.length === 0 &&
                      transportData.role !== undefined
                    ) {
                      transportDataAfterSubmit.role = transportData.role;
                    }
                  }

                  const sbsDataAfterSubmit = {};
                  if (isSbsWorker) {
                    sbsDataAfterSubmit.isActive = data.isSbsActive;
                    sbsDataAfterSubmit.sbsDistricts = data.sbsDistrict;
                    sbsDataAfterSubmit.sbsBuildings = data.sbsBuilding;
                    sbsDataAfterSubmit.role = data.sbsRole;
                    if (
                      data.sbsRole.length === 0 &&
                      sbsDataAfterSubmit.role !== undefined
                    ) {
                      sbsDataAfterSubmit.role = sbsDataAfterSubmit.role;
                    }
                  }
                  const securebaseDataAfterSubmit = {};
                  if (isSecurebaseWorker) {
                   // console.log("dataSB",data);
                    securebaseDataAfterSubmit.isActive = data.isSecurebaseActive;
                    securebaseDataAfterSubmit.sbDistricts = data.sbDistrict;
                    securebaseDataAfterSubmit.sbBuildings = data.sbBuilding;
                    if(data.securebaseRole !== null)
                    {
                      securebaseDataAfterSubmit.role = data.securebaseRole;
                    }else{
                      securebaseDataAfterSubmit.role = "";
                    }
                    // if (
                    //   data.securebaseRole.length == 0 &&
                    //   securebaseDataAfterSubmit.role !== undefined
                    // ) {
                    //   securebaseDataAfterSubmit.role = securebaseDataAfterSubmit.role;
                    // }
                  }
                  
                  const smartSortUserDataAfterSubmit = {};
                  if (isSmartSortWorker) {
                    smartSortUserDataAfterSubmit.isActive = data.isSmartSortActive;
                    // smartSortUserDataAfterSubmit.region = data.smartSortRegion;
                    // smartSortUserDataAfterSubmit.recordCenter = data.recordCenter;
                    smartSortUserDataAfterSubmit.role = data.smartSortRole;
                    smartSortUserDataAfterSubmit.onlDistricts = data.smartSortDistrict;
                    smartSortUserDataAfterSubmit.onlBuildings = data.smartSortBuilding;


                    smartSortUserDataAfterSubmit.userId = data.userId;
                    if (
                      data.smartSortRole.length === 0 &&
                      smartSortUserDataAfterSubmit.role !== undefined
                    ) {
                      smartSortUserDataAfterSubmit.role = smartSortUserDataAfterSubmit.role;
                    }
                  }
                 
                  const imTimeAccessDataAfterSubmit = {};
                  if (isIMtimeWorker) {
                    imTimeAccessDataAfterSubmit.isActive = data.isIMTimeActive;
                    imTimeAccessDataAfterSubmit.role = data.imTimeRole;
                    imTimeAccessDataAfterSubmit.isScannerOnly = data.isScannerOnly;
                    if (
                      data.imTimeRole.length === 0 &&
                      imTimeAccessDataAfterSubmit.imTimeRole !== undefined
                    ) {
                      imTimeAccessDataAfterSubmit.role =
                        imTimeAccessDataAfterSubmit.role;
                    }
                  }
                  const gorpaAccessDataAfterSubmit={};
                  if(isGorpaWorker){
                    gorpaAccessDataAfterSubmit.isActive = data.isGorpaActive;
                    gorpaAccessDataAfterSubmit.role = data.gorpaRole;
                    if(
                      data.gorpaRole.length === 0 &&
                      gorpaAccessDataAfterSubmit.gorpaRole !== undefined
                    ){
                      gorpaAccessDataAfterSubmit.role = 
                      gorpaAccessDataAfterSubmit.role;
                    }
                  }
                  console.log("gorpaSubmit", gorpaAccessDataAfterSubmit);

                  const crozierDataAfterSubmit = {};
                  if (isCrozierWorker) {
                    crozierDataAfterSubmit.isActive = data.isCrozierActive;
                    crozierDataAfterSubmit.crozierDistrict =
                      data.crozierDistrict;
                    crozierDataAfterSubmit.crozierBuildings =
                      data.crozierBuilding;
                  }

                  console.log(
                    "TRANSPPORT DATA AFTER SUBMIT ",
                    transportDataAfterSubmit
                  );
                  console.log("SBS DATA AFTER SUBMIT ", sbsDataAfterSubmit);
                  console.log("Securebase DATA AFTER SUBMIT ", securebaseDataAfterSubmit);
                  //console.log("Smart Sort User DATA AFTER SUBMIT ", smartSortUserDataAfterSubmit);
                  console.log(
                    "IM TIME ACCESS DATA AFTER SUBMIT ",
                    imTimeAccessDataAfterSubmit
                  );
                  console.log("GORPA DATA AFTER SUBMIT", gorpaAccessDataAfterSubmit);
                  console.log(
                    "CROZIER DATA AFTER SUBMIT ",
                    crozierDataAfterSubmit
                  );

                  // Couples datatRestricted and trDistricts
                  // if (!data.districtRestricted) {
                  //   if (transportData.trDistricts !== undefined) {
                  //     transportDataAfterSubmit.trDistricts =
                  //       transportData.trDistricts;
                  //   } else {
                  //     transportDataAfterSubmit.trDistricts = [];
                  //   }
                  // } else {
                  //   transportDataAfterSubmit.trDistricts =
                  //     data.transportDistrict;
                  // }

                  delete data.isTransportActive;
                  delete data.districtRestricted;
                  delete data.transportDistrict;
                  delete data.transportRole;
                  delete data.isSbsActive;
                  delete data.sbsDistrict;
                  delete data.sbsBuilding;
                  delete data.sbsRole;
                  delete data.isSecurebaseActive;
                  delete data.sbDistrict;
                  delete data.sbBuilding;
                  delete data.securebaseRole;
                  delete data.smartSortRole;
                  delete data.isSmartSortActive;
                  delete data.smartSortDistrict;
                  delete data.smartSortBuilding;
                  // delete data.smartSortRegion;
                  // delete data.recordCenter;
                  delete data.userId;
                  delete data.isCrozierActive;
                  delete data.crozierDistrict;
                  delete data.crozierBuilding;
                  delete data.isIMTimeActive;
                  delete data.isGorpaActive;
                  delete data.imTimeRole;
                  delete data.gorpaRole;
                  delete data.isScannerOnly;
                  const defaultObj = {
                    workingHoursEnabled: false,
                    meal: { enabled: false, value: "30 mins" },
                    dayHours: { enabled: false, value: "8 Hours" },
                    weekHours: { enabled: false, value: "40 Hours" }
                  };
                  console.log(
                    "comparing both the objects ",
                    deepEqual(defaultObj, data)
                  );

                  const defWorkhrsObj = {
                    dayHours: { enabled: false, value: "8 Hours" },
                    weekHours: { enabled: false, value: "40 Hours" }
                  }

                  const savedWorkHours = Object.keys(workingHourData).length>0 ?{
                    dayHours: workingHourData?.dayHours,
                    weekHours: workingHourData?.weekHours
                  } :{}

                  let savedWorkHoursDaysData = {};
                  if(Object.keys(workingHourData).length>0){
                    let {actionBy, actionTS, actionType, ...remaining} =  workingHourData;
                    savedWorkHoursDaysData = {...remaining};
                  } 

                  console.log(
                    " defaultObj and data ",
                    defaultObj,
                    "data",
                    data,
                    workingHourData,
                    savedWorkHoursDaysData
                  );


                  console.log("gdeDataAfterSubmit1", gdeDataAfterSubmit);

                  if (deepEqual(savedWorkHoursDaysData, data)) {
                    console.log("both the objects are equal 1");
                    console.log("gdeDataAfterSubmit2", gdeDataAfterSubmit);

                    handleSave(
                      null,
                      gdeDataAfterSubmit,
                      transportDataAfterSubmit,
                      sbsDataAfterSubmit,
                      crozierDataAfterSubmit,
                      imTimeAccessDataAfterSubmit,
                      gorpaAccessDataAfterSubmit,
                      smartSortUserDataAfterSubmit,
                      securebaseDataAfterSubmit
                    );
                  } else if (
                    isEmptyObject(worker) &&
                    deepEqual(defaultObj, data)
                  ) {
                    console.log("both the objects are equal");
                    handleSave(
                      null,
                      gdeDataAfterSubmit,
                      transportDataAfterSubmit,
                      sbsDataAfterSubmit,
                      crozierDataAfterSubmit,
                      imTimeAccessDataAfterSubmit,
                      gorpaAccessDataAfterSubmit,
                      smartSortUserDataAfterSubmit,
                      securebaseDataAfterSubmit
                    );
                  } else if (deepEqual(defaultObj, data) && (isEmptyObject(workingHourData) || deepEqual(defWorkhrsObj,savedWorkHours))) {
                    console.log("both the objects are equal");
                    console.log("gdeDataAfterSubmit3", gdeDataAfterSubmit);

                    handleSave(
                      null,
                      gdeDataAfterSubmit,
                      transportDataAfterSubmit,
                      sbsDataAfterSubmit,
                      crozierDataAfterSubmit,
                      imTimeAccessDataAfterSubmit,
                      gorpaAccessDataAfterSubmit,
                      smartSortUserDataAfterSubmit,
                      securebaseDataAfterSubmit
                    );
                  } else {
                    const modifiedSchuduleData = Object.keys(data)
                      .filter((k) => k != "workingHoursEnabled" && k != "meal" && k != "dayHours" && k!="weekHours")
                      .filter((s) => data[s].slots !== undefined)
                      .reduce((a, c) => ({ ...a, [c]: data[c] }), {});
                    modifiedSchuduleData.meal = data.meal;
                    modifiedSchuduleData.dayHours = data.dayHours;
                    modifiedSchuduleData.weekHours = data.weekHours;
                    modifiedSchuduleData.workingHoursEnabled =
                      data.workingHoursEnabled;
                    console.log("gdeDataAfterSubmit4", gdeDataAfterSubmit);
                    handleSave(
                      modifiedSchuduleData,
                      gdeDataAfterSubmit,
                      transportDataAfterSubmit,
                      sbsDataAfterSubmit,
                      crozierDataAfterSubmit,
                      imTimeAccessDataAfterSubmit,
                      gorpaAccessDataAfterSubmit,
                      smartSortUserDataAfterSubmit,
                      securebaseDataAfterSubmit
                    );
                  }
                })}

              // className={classes.button}
              >
                {t("pgAddWorker.btnSave")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Dialog
        open={confirmationMsg}
        onClose={closeModalConfirmationMsg}
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isEmptyObject(worker)
              ? `${t("pgAddWorker.lblconfirmationMsgText")} ${newWorkerId && "with ID = " + newWorkerId
              }.`
              : t("pgAddWorker.lblEditConfirmationMsgText")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalConfirmationMsg} color="primary">
            {t("pgAddWorker.btnOk")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={errorMsg} onClose={closeModalErrorMsg} disableBackdropClick>
        <DialogTitle id="form-dialog-title">Error</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("pgAddWorker.lblErrorMsgText")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalErrorMsg} color="primary">
            {t("pgAddWorker.btnOk")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errorExceptionMsg}
        onClose={closeModalErrorExceptionMsg}
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">Error</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("other.tlAddWorkerErrorMsg")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalErrorExceptionMsg} color="primary">
            {t("pgAddWorker.btnOk")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  return <>{isLoading ? <CircularProgress /> : workerMarkup}</>;
};

AddWorkerView.propTypes = {
  setShowUpload: PropTypes.func,
};

export default AddWorkerView;
